import {
  joinApiUrl,
  resolveCccApiBase,
  resolveMainApiBase,
} from './config/env';

/**
 * CCC frontend — API base URLs.
 * Production on ccc.* uses same-origin `/api` paths (Nginx reverse proxy).
 * Set VITE_MAIN_API_URL / VITE_CCC_API_URL only when bypassing the proxy.
 */
export const getCccApiBase = (): string => resolveCccApiBase();

export const getMainApiBase = (): string => resolveMainApiBase();

/** Build a full request URL for main CRM routes (`/api/comercial/...`, etc.). */
export const mainApiUrl = (path: string): string => joinApiUrl(getMainApiBase(), path);

/** Build a full request URL for CCC routes (`/api/ccc/...`). */
export const cccApiUrl = (path: string): string => joinApiUrl(getCccApiBase(), path);

export { joinApiUrl } from './config/env';

import {
  getMainCrmAppUrl,
  getMainCrmLoginUrl,
  getCccAppUrl,
  getCccAppPath,
} from '@crm/config/crmAppUrls';

export { getMainCrmAppUrl, getMainCrmLoginUrl, getCccAppUrl, getCccAppPath };

/** @deprecated Use getMainCrmAppUrl */
export const getMainCrmUrl = () => getMainCrmAppUrl();
